export default null;

export const INIT_PRO_DELIVERY = {
	temporaryId: '', // 입력값이 어느 신청번호의 것인지 (sessionStorage persist가 신청번호와 무관하게 공유되므로 필요)
	sidoCode: '',
	buildingCode: '',
	postalCode: '',
	roadPart: '',
	detailPart: '',
	date: '',
	time: '',
	availableDateTimeList: [],
	accountHolderName: '',
	bankCode: '',
	accountNumber: '',
};
